import { useEffect, useState } from 'react';
import * as yup from 'yup';

/**
 * determine wether is client side or not, inside react component
 * @returns state managed bool wether its clientside
 */
export const useIsClientSide = () => {
    const [isClientSide, setIsClientSide] = useState(false);
    useEffect(() => {
        setIsClientSide(true);
    }, []);
    return isClientSide;
};

type Errors = Record<string, unknown>;

export function useValidator<T extends object>(schema: yup.AnyObjectSchema, data: T) {
    const [errors, setErrors] = useState<Errors>({});
    const [isValid, setIsValid] = useState<boolean>(true);

    useEffect(() => {
        schema
            .validate(data, { abortEarly: false, disableStackTrace: true })
            .then(() => {
                setErrors({});
                setIsValid(true);
            })
            .catch(err => {
                if (err instanceof yup.ValidationError) {
                    const normalized: Errors = {};
                    for (const e of err.inner) {
                        if (e.path && !normalized[e.path]) {
                            normalized[e.path] = e.message;
                        }
                    }
                    setErrors(normalized);
                    setIsValid(false);
                } else {
                    throw err;
                }
            });
    }, [data, schema]);

    return { errors, isValid };
}
